import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import { translate } from '../../i18n/customI18nProvider';
import config from '../../config';
import Swal from 'sweetalert2';
import {
    SimpleForm,
    Toolbar,
    useRefresh,
    AutocompleteArrayInput
} from 'react-admin';
import { convertMessageCodeToMessage } from '../../util';
import { IconButton, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField } from '@material-ui/core';
import { getNumberOfUsedClients, getPacketDetailsByShortId, getUsedPackets, getWristbandsStatus, unactivatePackets } from '../../services/wristbandCategory.service';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import { Chip } from '@mui/material';

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxHeight: '90vh',
    overflowY: 'auto'
  },
  paper: {
    backgroundColor: 'whitesmoke',
    // border: '2px solid #000',
    borderRadius: '10px',
    // boxShadow: '10px 10px 5px #8d9093',
    padding: '20px',
    minWidth: '80vw'
  },
  sub_paper: {
    backgroundColor: 'whitesmoke',
    // border: '2px solid #000',
    borderRadius: '10px',
    // boxShadow: '10px 10px 5px #8d9093',
    padding: '20px',
    minWidth: '60vw'
  }
};

const ClientCancelPacketToolbar = props => (
    <Toolbar {...props} style={{visibility: 'hidden', display: 'none'}} ></Toolbar>
);

let myChoices = [];

class ClientCancelPacketClass extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            packetShortIds: [],
            used_packet: [],
            packets: [],
            event_id: null,
            wristband_packet_detail: { open: false, packet: null, details: [] }
        }

        this.deleteClients = this.deleteClients.bind(this);
        this.onClick = props.onClick;
    }

    async componentDidMount() {
        this.fetchUsedPackets();
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.packetShortIds !== this.state.packetShortIds) {
            const input = document.getElementById("packet-short-ids-input");
            if (input) {
                input.focus();
            }
        }

        if(!prevState.open && this.state.open) {
            // Modal just opened give focus to input
            setTimeout(() => {
                const input = document.getElementById("packet-short-ids-input");
                if (input) {
                    input.focus();
                }
            }, 0);
        }
    }

    handleOpen = () => {
        this.setState({open: true});
    }

    handleClose = () => {
        this.setState({
            open: false,
            packetShortIds: [],
            packets: []
        });
        myChoices = [];
        this.onClick()
    }

    fetchUsedPackets = async () => {
        try {
            const response = await getUsedPackets();
            if(!response.error) {
                const packetChoices = response.map(packet => ({id: packet.shortId, name: packet.shortId}));
                this.setState({used_packet: packetChoices});
            }
        } catch (error) {
            console.log("Error fetching used packets: ", error.message);
        }
    }

    skippedPacketRender = (packets) => {
        if (!packets || packets.length === 0) return '';

        // Génération des "Chips" en HTML
        const chipsHtml = packets.map(packet => `
            <span style="
                display: inline-block;
                background-color: #ed6c02; /* Couleur warning de MUI */
                color: #fff;
                padding: 4px 8px;
                margin: 0 4px 5px 0;
                border-radius: 16px;
                font-family: monospace;
                font-size: 0.85rem;
                font-weight: bold;
            ">
                ${packet}
            </span>
        `).join('');

        // Accordéon natif en HTML (<details> et <summary>)
        return `
            <details style="text-align: left; margin-top: 10px;">
                <summary style="cursor: pointer; font-weight: bold; font-family: sans-serif; outline: none;">
                    ${translate('custom.packets_containing_skipped_clients')}
                </summary>
                <div style="margin-top: 10px; display: flex; gap: 10px; flex-wrap: wrap;">
                    ${chipsHtml}
                </div>
            </details>
        `;
    }

    failedPacketRender = (packets) => {
        if (!packets || packets.length === 0) return '';

        // Génération des "Chips" en HTML
        const chipsHtml = packets.map(packet => `
            <span style="
                display: inline-block;
                background-color: #d32f2f; /* Couleur error de MUI */
                color: #fff;
                padding: 4px 8px;
                margin: 0 4px 5px 0;
                border-radius: 16px;
                font-family: monospace;
                font-size: 0.85rem;
                font-weight: bold;
            ">
                ${packet}
            </span>
        `).join('');

        // Accordéon natif en HTML
        return `
            <details style="text-align: left; margin-top: 10px;">
                <summary style="cursor: pointer; font-weight: bold; font-family: sans-serif; outline: none;">
                    ${translate('custom.packets_containing_failed_clients')}
                </summary>
                <div style="margin-top: 10px; display: flex; gap: 10px; flex-wrap: wrap;">
                    ${chipsHtml}
                </div>
            </details>
        `;
    }

    async deleteClients() {
        const count = this.state.packets.reduce((sum, packet) => sum + (packet.count && !isNaN(Number(packet.count)) ? Number(packet.count) : 0), 0);

        if(count === 0) {
            Swal.fire({
                icon: 'info',
                title: translate('custom.info'),
                text: translate('custom.no_clients_to_delete_in_selected_packets'),
                confirmButtonColor: config.baseColor
            });
            return;
        }

        let c = await Swal.fire({
            icon: 'warning',
            title: translate('custom.warning'),
            text: translate('custom.are_you_sure_you_want_to_delete_clients').replace('{{count}}', count),
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: translate('custom.yes'),
            cancelButtonText: translate('custom.no'),
            confirmButtonColor: config.baseColor
        });
        if(!c.isConfirmed)
            return;

        
        try {
            let response = await unactivatePackets(this.state.packets);

            if(response.error) {
                Swal.fire({
                    title: translate('custom.error'),
                    text: response.error_code ? (convertMessageCodeToMessage(response.error_code)) : (response.error ? response.error : translate('custom.unknown_error')),
                    icon: 'error',
                    confirmButtonText: translate('custom.ok'),
                    confirmButtonColor: config.baseColor
                });
            } else {
                let skippedPackets = [];
                let failedPackets = [];
                for(const warning of response.warnings || []) {
                    if(skippedPackets.includes(warning.shortId)) continue;
                    skippedPackets.push(warning.shortId);
                }
                for(const error of response.errors || []) {
                    if(failedPackets.includes(error.shortId)) continue;
                    failedPackets.push(error.shortId);
                }

                let success = response.deleted_count;
                let skipped = response.warnings?.length || 0;
                let failure = response.errors?.length || 0;
                Swal.fire({
                    title: translate('custom.delete_completed'),
                    html: translate('custom.success') + ": " + success + "<br>"  +
                            translate('custom.failure') + ": " + failure + "<br>" +
                            translate('custom.skipped') + ": " + skipped + "<br>" +
                            (skippedPackets.length > 0 ? this.skippedPacketRender(skippedPackets) : '') +
                            (failedPackets.length > 0 ? this.failedPacketRender(failedPackets) : ''),
                    icon: 'success',
                    confirmButtonText: translate('custom.ok'),
                    confirmButtonColor: config.baseColor
                });
                if(success > 0) {
                    this.props.refresh();
                    this.handleClose();
                }
            }
        } catch(e) {
            Swal.fire({
                title: translate('custom.error'),
                text: e.message ? e.message : translate('custom.unknown_error'),
                icon: 'error',
                confirmButtonText: translate('custom.ok'),
                confirmButtonColor: config.baseColor
            });
        } 

    }

    findPacketsByShortId(shortId) {
        return this.state.packets.find(packet => packet.shortId === shortId);
    }

    async refreshPackets(packetShortIds) {
        for(const shortId of packetShortIds) {
            const packet = this.findPacketsByShortId(shortId);
            if(!packet) {
                // Fetch packet details
                let packetData = {
                    shortId: shortId,
                    error: translate('custom.packet_not_found'),
                }
                try {
                    const response = await getNumberOfUsedClients(shortId);
                    if(response._id) {
                        packetData = {
                            shortId: shortId,
                            count: response.count.used > 0 ? 0 : response.count.activated,
                            used: response.count.used,
                            activated: response.count.activated,
                            non_activated: response.count.non_activated,
                            on_other_event: response.count.on_other_event,
                        }
                    }
                } catch (error) {
                    console.log("Error fetching packet details: ", error.message);
                }
                this.setState({packets: [...this.state.packets, {...packetData}]});
            }
        }
        this.setState({packets: this.state.packets.filter(packet => packetShortIds.includes(packet.shortId))});
        myChoices = packetShortIds.map(id => ({id: id, name: id}));
    }

    fetchPacketDetails = async (packet) => {
        try {
            const response = await getWristbandsStatus(packet.shortId);
            const statusOrder = {
                'used': 1,
                'on_other_event': 2,
                'non_activated': 3,
                'activated': 4
            };

            const orderedDetails = response.wristbandsStatus.sort((a, b) => {
                const priorityA = statusOrder[a.status] || 99;
                const priorityB = statusOrder[b.status] || 99;                
                return priorityA - priorityB;
            });

            this.setState({wristband_packet_detail: {...this.state.wristband_packet_detail, details: orderedDetails}});
        } catch (error) {
            console.log("Error fetching packet details: ", error.message);
        }
    }

    handleChangePackets = async (value) => {
        this.setState({packetShortIds: value});
        this.refreshPackets(value);
    }

    packetRow(packet) {

        const generateWarningTitle = (packet) => {
            let title = '';
            if(packet.used > 0) {
                title += packet.used + ' ' + translate('custom.clients_used') + '\n';
            }
            if(packet.non_activated > 0) {
                title += packet.non_activated + ' ' + translate('custom.clients_not_activated') + '\n';
            }
            if(packet.on_other_event > 0) {
                title += packet.on_other_event + ' ' + translate('custom.clients_on_other_event') + '\n';
            }
            return title;
        };

        const generateStatusBadge = (packet) => {
            const handleClick = () => { 
                this.setState({wristband_packet_detail: {open: true, packet: packet, detail: []}})
                this.fetchPacketDetails(packet);
            }
            if(packet.error) {
                return <div><ErrorIcon color="error" /></div>;
            }
            if(packet.used > 0) {
                return <div title={generateWarningTitle(packet)} style={{ cursor: 'pointer' }} onClick={handleClick}><ErrorIcon color="error" /></div>;
            }
            if(packet.non_activated > 0 || packet.on_other_event > 0) {
                return <div title={generateWarningTitle(packet)} style={{ cursor: 'pointer' }} onClick={handleClick}><WarningIcon color="warning" /></div>;
            }
            return <CheckCircleIcon color="success" />;
        }

        return (
            <TableRow
              key={packet.shortId}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <TableCell>{generateStatusBadge(packet)}</TableCell>
                <TableCell component="th" scope="row">{packet.shortId}</TableCell>
                {
                    packet.error ? (
                        <TableCell style={{color: 'red'}}>{packet.error}</TableCell>
                    ) : (
                        <>
                            <TableCell align="right">{packet.count}</TableCell>
                        </>
                    )
                }
                <TableCell style={{ width: '1px', whiteSpace: 'nowrap' }}>
                    <IconButton
                        color="secondary"
                        onClick={() => {
                            const newPacketShortIds = this.state.packetShortIds.filter(id => id !== packet.shortId);

                            this.setState({
                                packetShortIds: newPacketShortIds,
                                packets: this.state.packets.filter(p => p.shortId !== packet.shortId)
                            });
                            myChoices = newPacketShortIds.map(id => ({id: id, name: id}));
                        }}
                        variant="contained"
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
        )
    }

    showPacketDetails(packet) {
        if(!packet) return null;
        const openWristbandPage = (uid) => {
            window.open('/' + uid, '_blank');
        }
        const countByStatus = {
            activated: 0,
            non_activated: 0,
            on_other_event: 0,
            used: 0
        };
        this.state.wristband_packet_detail.details?.forEach(detail => {
            if(countByStatus[detail.status] !== undefined) {
                countByStatus[detail.status]++;
            }
        });
        return (
            <div>
                <h2>{translate('custom.wristband_packet_details')} - {packet.shortId}</h2>
                <div style={{display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '20px'}}>
                    <Chip label={countByStatus.activated + ' ' + translate('custom.wristband_count')} color="primary" />
                    <Chip label={countByStatus.non_activated + ' ' + translate('custom.wristband_non_activated')} color="warning" />
                    <Chip label={countByStatus.on_other_event + ' ' + translate('custom.wristband_on_other_event')} color="warning" />
                    <Chip label={countByStatus.used + ' ' + translate('custom.wristband_used')} color="error" />
                </div>
                <div style={{maxHeight: '60vh', overflowY: 'auto', display: 'grid', gap: '10px', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 2fr))'}} >
                    {
                        this.state.wristband_packet_detail.details?.map((detail, index) => (
                            <div key={index} style={{display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px'}}>
                                <Chip onClick={() => openWristbandPage(detail.uid)} sx={{width: '200px', cursor: 'pointer'}} label={detail.uid} variant="outlined" />
                                <Chip label={translate(`custom.wristband_status.${detail.status}`) + (detail.status == 'on_other_event' ? ' - ' + detail.event?.name : '')} color={
                                    detail.status === 'used' ? 'error' :
                                    detail.status === 'non_activated' ? 'warning' :
                                    detail.status === 'on_other_event' ? 'warning' :
                                    'primary'
                                } />
                            </div>
                        ))
                    }
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>                
                <MenuItem onClick={this.handleOpen}>
                    {translate('custom.cancel_packets')}
                </MenuItem>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    // className={classes.modal}
                    style={styles.modal}
                    open={this.state.open}
                    onClose={this.handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={this.state.open}>
                        <div style={styles.paper}>
                            <SimpleForm toolbar={<ClientCancelPacketToolbar />} >
                                <AutocompleteArrayInput fullWidth label={translate('custom.packets')} source="packetShortIds" choices={[...myChoices, ...this.state.used_packet]} variant='outlined'
                                    defaultHighlightedIndex={0}
                                    key={JSON.stringify(this.state.packetShortIds)}
                                    id="packet-short-ids-input"
                                    format={() => this.state.packetShortIds}
                                    parse={value => {
                                        this.handleChangePackets(value);
                                        return value;
                                    }}
                                    onCreate={(text) => {
                                        text = text.toUpperCase().trim();
                                        if(text != "") {
                                            const newTag = { id: String(text), name: text };
                                            const existantChoice = [...myChoices, ...this.state.used_packet].find((choice) => choice.id === newTag.id);
                                            if (existantChoice) {
                                                return existantChoice;
                                            } else {
                                                myChoices.push(newTag);
                                                return newTag;
                                            }
                                        } else {
                                            return Promise.reject("Texte vide");
                                        }
                                    }}
                                />

                                <TableContainer component={Paper} style={{width: '100%', marginTop: '20px', marginBottom: '20px', maxHeight: '500px'}}>
                                    <Table aria-label="simple table" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell>{translate('custom.short_id')}</TableCell>
                                                <TableCell align='right'>{translate('custom.number_of_clients')}</TableCell>
                                                <TableCell align='right' sx={{ width: '1%', whiteSpace: 'nowrap' }}></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            { 
                                                this.state?.packets && this.state.packets.length > 0 ? this.state.packets.map((packet) => this.packetRow(packet)) : 
                                                <TableRow>
                                                    <TableCell colSpan={6} align='center'>
                                                        {translate('custom.no_packets_selected')}
                                                    </TableCell>
                                                </TableRow>
                                            }
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow style={{ position: "sticky", bottom: 0, backgroundColor: "whitesmoke"}}>
                                                <TableCell style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    {translate('custom.total')}
                                                </TableCell>
                                                <TableCell style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    { this.state.packets.length }
                                                </TableCell>
                                                <TableCell style={{fontWeight: 'bold', fontSize: '14px'}} align='right'>
                                                    { this.state.packets.reduce((sum, packet) => sum + (packet.count && !isNaN(Number(packet.count)) ? Number(packet.count) : 0), 0) }
                                                </TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>

                                <Button
                                    style={{color: 'white', backgroundColor: '#f44336', marginTop: '20px'}}
                                    onClick={this.deleteClients}
                                    variant="contained"
                                    size="small"
                                    fullWidth={true}
                                >
                                    {translate('custom.delete')}
                                </Button>

                            </SimpleForm>

                        </div>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    style={styles.modal}
                    open={this.state.wristband_packet_detail.open}
                    onClose={() => this.setState({wristband_packet_detail: {open: false, packet: null, details: []}})}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={this.state.wristband_packet_detail.open}>
                        <div style={styles.sub_paper}>
                            {this.showPacketDetails(this.state.wristband_packet_detail.packet)}
                        </div>
                    </Fade>

                </Modal>
            </div>
        );
    }

}

const ClientCancelPacket = (props) => {
    
    const refresh = useRefresh();
    return <ClientCancelPacketClass {...props} refresh={refresh} />
}
export default ClientCancelPacket;